"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@21st-night/core");
var Tabs_1 = __importDefault(require("../../Tabs"));
var Tab_1 = __importDefault(require("../../Tab"));
var DeckTabsDropdownMenu_1 = __importDefault(require("../DeckTabsDropdownMenu"));
var constants_1 = require("../constants");
var TAB_COUNT = 6;
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            maxWidth: '100vw',
            marginTop: 16,
            minHeight: 80,
        },
        centered: {
            justifyContent: 'center',
        },
        children: {
            marginLeft: 'auto',
        },
    });
});
var DeckTabs = function (_a) {
    var _b;
    var children = _a.children, onChange = _a.onChange, value = _a.value, other = __rest(_a, ["children", "onChange", "value"]);
    var tabsRef = react_1.useRef(null);
    var childrenRef = react_1.useRef(null);
    var windowSize = core_1.useWindowSize();
    var classes = exports.useStyles();
    var _c = __read(react_1.useState([]), 2), hiddenTabs = _c[0], setHiddenTabs = _c[1];
    react_1.useEffect(function () {
        var tabsElement = tabsRef.current;
        var childrenElement = childrenRef.current;
        if (tabsElement) {
            var width = tabsElement.clientWidth;
            var childrenWidth = 0;
            if (childrenElement) {
                childrenWidth = childrenElement.clientWidth;
            }
            width -= childrenWidth;
            var tabs = [];
            if (width < 206) {
                tabs.push('notes');
            }
            if (width < 353) {
                tabs.push('cards');
            }
            if (width < 478) {
                tabs.push('cheat-sheet');
            }
            if (width < 579) {
                tabs.push('analytics');
            }
            if (width < 630) {
                tabs.push('share');
                tabs.push('settings');
            }
            setHiddenTabs(tabs);
        }
    }, [windowSize.width, tabsRef, children]);
    return (react_1.default.createElement("div", { ref: tabsRef, className: clsx_1.default(classes.root, (_b = {},
            _b[classes.centered] = hiddenTabs.length === TAB_COUNT,
            _b)) },
        react_1.default.createElement(Tabs_1.default, __assign({ centered: hiddenTabs.length === TAB_COUNT, value: value, 
            // See https://github.com/mui-org/material-ui/issues/17454
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            onChange: onChange }, other),
            !hiddenTabs.includes('notes') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames.notes, value: "notes" })),
            !hiddenTabs.includes('cards') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames.cards, value: "cards" })),
            !hiddenTabs.includes('cheat-sheet') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames['cheat-sheet'], value: "cheat-sheet" })),
            !hiddenTabs.includes('analytics') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames.analytics, value: "analytics" })),
            !hiddenTabs.includes('share') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames.share, value: "share" })),
            !hiddenTabs.includes('settings') && (react_1.default.createElement(Tab_1.default, { label: constants_1.tabNames.settings, value: "settings" })),
            hiddenTabs.length > 0 && (react_1.default.createElement(DeckTabsDropdownMenu_1.default, { value: hiddenTabs.includes(value) ? value : undefined, activeTab: value, menuItems: hiddenTabs, useActiveTabAsLabel: hiddenTabs.length === TAB_COUNT, onSelectTab: onChange }))),
        hiddenTabs.length !== TAB_COUNT && (react_1.default.createElement("div", { ref: childrenRef, className: classes.children }, children))));
};
exports.default = DeckTabs;
//# sourceMappingURL=DeckTabs.js.map